
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class AssetTagView extends Vue {
  @Prop({
    required: true,
    default: {},
  }) conf!: { name: string, imgUrl: any };

  @Prop({
    required: false,
    default: true,
  }) cover!: boolean;

  @Prop({
    default: 0,
  }) badge!: number;
}
